import { render, staticRenderFns } from "./RankSettings.vue?vue&type=template&id=399a28dd&scoped=true"
import script from "./RankSettings.vue?vue&type=script&lang=js"
export * from "./RankSettings.vue?vue&type=script&lang=js"
import style0 from "./RankSettings.vue?vue&type=style&index=0&id=399a28dd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a28dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('399a28dd')) {
      api.createRecord('399a28dd', component.options)
    } else {
      api.reload('399a28dd', component.options)
    }
    module.hot.accept("./RankSettings.vue?vue&type=template&id=399a28dd&scoped=true", function () {
      api.rerender('399a28dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/operationsManagement/Component/RankSettings.vue"
export default component.exports